import React from 'react';
import Proptypes from 'prop-types';
import Icon from '../icon/Icon';
import './what-we-offer-item.scss';

const WhatWeOfferItem = ({
  description,
  smallTitle,
  bigTitle,
  iconName,
  iconDescription,
  linkUrl,
  linkText,
  tooltip
}) => {

  return (
    <div className="what-we-offer-item">
      <div className="what-we-offer-item__icon">
        <Icon iconName={iconName}>{iconDescription}</Icon>
      </div>
      <div className="what-we-offer-item__text">
        <div className="what-we-offer-item__header">
          <div>{smallTitle}</div>
          <div className="what-we-offer-item__header-large">{bigTitle()}</div>
        </div>
        <div className="what-we-offer-item__description">
          {description}
        </div>
        {
          (linkUrl && !tooltip) ? (
            <a
              className="u__default-link"
              href={linkUrl}
              rel="noreferrer"
              target="_blank"
            >
              {linkText}
            </a>
          )
            : null
        }
        {
          tooltip && (tooltip(linkUrl, linkText))
        }
      </div>
    </div>
  );
};

WhatWeOfferItem.propTypes = {
  description: Proptypes.string.isRequired,
  smallTitle: Proptypes.string.isRequired,
  bigTitle: Proptypes.func.isRequired,
  iconName: Proptypes.string.isRequired,
  iconDescription: Proptypes.string.isRequired,
  linkUrl: Proptypes.string.isRequired,
  linkText: Proptypes.string.isRequired,
  tooltip: Proptypes.func,
};

WhatWeOfferItem.defaultProps = {
  tooltip: null,
};

export default WhatWeOfferItem;